'use client';
import '@suits/ss-design-system/dist/ss-components/ss-components.css';
import '../../globals.scss';
import Button, { ButtonType } from '@susu/custom-made/components/button/button';
import Loader from '@susu/custom-made/components/loader/loader';
import type { Locale } from '@susu/custom-made/i18n-config';
import type { ClientType, ConfiguratorOrigin } from '@susu/custom-made/utils/constants';
import type { ProductType } from '@susu/custom-made/utils/productDefinition';
import { useState } from 'react';

import styles from './AppSwitcher.module.scss';
import { navigate } from './redirectActions';

interface AppSwithcerProps {
  language: string;
  countryCode: string;
  client: ClientType;
  product: ProductType;
  tokenIdentifierKey: string;
  storeID: string;
  customerID: string;
  productCode: string | string[];
  sizeId: string;
  configurationId: string;
  origin: ConfiguratorOrigin;
  search: string;
}

function AppSwitcher(props: Readonly<AppSwithcerProps>) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    language,
    countryCode,
    client,
    product,
    tokenIdentifierKey,
    storeID,
    customerID,
    productCode,
    sizeId,
    configurationId,
    origin,
    search,
  } = props;

  const navigateClickHandler = (toNewUI: boolean) => {
    setIsLoading(true);

    navigate({
      language: language as Locale,
      countryCode: countryCode,
      client: client,
      product: product,
      toNewUI: toNewUI,
      tokenIdentifierKey: tokenIdentifierKey,
      storeID: storeID,
      customerID: customerID,
      productCode: productCode,
      sizeId: sizeId,
      configurationId: configurationId,
      origin: origin,
      search: search,
    });
  };

  return (
    <div className={styles.switcherContainer}>
      <span>Select your configurator: </span>
      <Button
        onClick={() => {
          navigateClickHandler(true);
        }}
        type={ButtonType.Primary}
        isRectangular={true}
        isFullSize={true}
      >
        <span className={styles.boldBtnTitle}>New</span>
      </Button>
      <Button
        onClick={() => navigateClickHandler(false)}
        type={ButtonType.Secondary}
        isRectangular={true}
        isFullSize={true}
      >
        <span>Existing</span>
      </Button>
      {isLoading && <Loader />}
    </div>
  );
}

export default AppSwitcher;
